<template>
    <v-card-text>
        <v-tabs v-model="tab" centered>
            <v-tabs-slider></v-tabs-slider>
            <v-tab href="#res">
                Residencial
            </v-tab>
            <v-tab href="#com">
                Comercial
            </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
            <v-tab-item value="res">
                <EnderecoResidencial :dados="dados"/>
            </v-tab-item>
            <v-tab-item value="com">
                <EnderecoComercial :dados="dados"/>
            </v-tab-item>
        </v-tabs-items>
    </v-card-text>
</template>

<script>
    import EnderecoResidencial from '@/components/perfil/EnderecoResidencial'
    import EnderecoComercial from '@/components/perfil/EnderecoComercial'
    export default{
        props:['dados'],
        components:{EnderecoResidencial, EnderecoComercial},
        data(){
            return{
                tab: {},
            }
        },
        watch:{
            
        },

        created(){
            
            
        }
    }
</script>

<style scoped>
</style>
